// src/components/SidebarMenu/useWarehouseResolver.js
import { useMemo, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { isSuperAdminUser } from '../../utils/userUtils'

export function useWarehouseResolver(user, setUser, openWarehouses) {
    const history = useHistory()
    const location = useLocation()

    const cachedId = user?.current_warehouse?.id

    // Extract only the warehouse segment so sub-path changes don't trigger recomputation
    const urlWarehouseSegment = useMemo(() => {
        const parts = location.pathname.split('/')
        return parts[2] || null
    }, [location.pathname])

    const warehouse_id = useMemo(() => {
        if (cachedId) return String(cachedId)
        if (!user || !openWarehouses) return null

        if (!urlWarehouseSegment || isNaN(parseInt(urlWarehouseSegment))) return null

        const foundIndex = openWarehouses.findIndex(
            (w) => w.id === parseInt(urlWarehouseSegment)
        )

        if (foundIndex === -1) return null

        if (user.warehouse_ids === undefined && !isSuperAdminUser(user) && !user.read_all_warehouses) {
            return urlWarehouseSegment
        }

        const hasAccess =
            isSuperAdminUser(user) ||
            user.read_all_warehouses ||
            (user.warehouse_ids && user.warehouse_ids.includes(parseInt(urlWarehouseSegment)))

        if (hasAccess) return urlWarehouseSegment
        return null
    }, [cachedId, user, openWarehouses, urlWarehouseSegment])

    useEffect(() => {
        if (!warehouse_id || !openWarehouses || !user) return
        if (cachedId) return

        const wh = openWarehouses.find((w) => w.id === parseInt(warehouse_id))
        if (wh && (!user.current_warehouse || user.current_warehouse.id !== wh.id)) {
            setUser({ ...user, current_warehouse: wh })
        }
    }, [warehouse_id, openWarehouses, user, cachedId, setUser])

    useEffect(() => {
        if (warehouse_id === null && user && openWarehouses) {
            if (urlWarehouseSegment && !isNaN(parseInt(urlWarehouseSegment))) {
                history.push('/')
            }
        }
    }, [warehouse_id, user, openWarehouses, urlWarehouseSegment, history])

    return warehouse_id
}
